<div class="card">
    <slot></slot>
</div>

<style>
    .card {
        background-color: #fff;
        border-radius: 15px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        padding: 1rem 1.2rem;
        margin: 1rem 0;
        position: relative;
        color: #333;
    }
</style>